// Utility functions for working with guide data

import type { GuideData, WordBankItem } from '../index.ts';
import { guideData, wordBank } from '../index.ts';

/**
 * Get guide data by unit and section
 */
export const getGuideByUnitAndSection = (unit: string | number, section: string | number): GuideData | undefined => {
    return guideData.find(
        (g) =>
            String(g.guide_content.section) === String(section) &&
            String(g.guide_content.unit) === String(unit)
    );
};

/**
 * Get word from word bank by ID
 */
export const getWordById = (id: number): WordBankItem | undefined => {
    return wordBank.find((w) => w.id === id);
};

/**
 * Get multiple words from word bank by IDs
 */
export const getWordsByIds = (ids: number[]): WordBankItem[] => {
    return ids
        .map((id) => wordBank.find((w) => w.id === id))
        .filter((word): word is WordBankItem => word !== undefined);
};

/**
 * Get all available units with guides
 */
export const getAvailableUnits = (): number[] => {
    return guideData.map(g => g.guide_content.unit).sort((a, b) => a - b);
};

/**
 * Get all available sections for a unit
 */
export const getAvailableSectionsForUnit = (unit: number): number[] => {
    return guideData
        .filter(g => g.guide_content.unit === unit)
        .map(g => g.guide_content.section)
        .sort((a, b) => a - b);
};

/**
 * Create a fallback guide content for units that don't have guide data yet
 */
export const createFallbackGuideContent = (unit: string | number, section: string | number) => {
    return {
        unit: Number(unit),
        section: Number(section),
        title: `Panduan Unit ${unit}`,
        description: "Pelajari tips tata bahasa dan frasa kunci untuk unit ini",
        keyPhraseTitle: "Frasa Kunci",
        phrases: [],
    };
};
